import React from "react";
import ReactDOM from "react-dom";
import configureStore from "./components/features/store/store";
import App from "./App";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { ThemeProvider } from "@mui/material";
import { theme } from "./components/Theme/Theme";

require("./index.css");

const store = configureStore();
let persistor = persistStore(store);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>  
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// serviceWorker.unregister();
